// Base server URL without any path (e.g., "localhost:8080" or "api.capitalflow.app")
export const base_server_url = import.meta.env.VITE_APP_API_BASE_URL

// API endpoint paths
export const GRAPHQL_ENDPOINT = '/graphql'
export const OAUTH_DISCORD_ENDPOINT = '/oauth/login/discord'
export const ABLY_TOKEN_ENDPOINT = '/ably-callbacks/token-request'

// Protocol determination: use HTTPS for remote APIs, HTTP only for localhost backends
const isLocalApi = base_server_url?.startsWith('localhost') || base_server_url?.startsWith('127.0.0.1')
const protocol = isLocalApi ? 'http' : 'https'

// URL builder functions
export const buildApiUrl = (endpoint = '') => `${protocol}://${base_server_url}${endpoint}`
export const graphql_url = buildApiUrl(GRAPHQL_ENDPOINT)
export const oauth_discord_url = buildApiUrl(OAUTH_DISCORD_ENDPOINT)
export const ably_token_url = buildApiUrl(ABLY_TOKEN_ENDPOINT)

// Legacy exports for backward compatibility
export const base_api_url = graphql_url
export const discord_oauth_url = oauth_discord_url

// Other constants
export const intrinio_api_key = import.meta.env.VITE_APP_INTRINIO_KEY
